import { RequestService } from '../../../../common/services/RequestService';
import { UPDATE_EXECUTOR } from '../constants';
import { adjustExecutor } from './adjustExecutorById';

export const restoreArchiveExecutorRequest = async (profileId, executorId) => {
  const response = await RequestService.put(
    UPDATE_EXECUTOR.replace('{profile_id}', profileId).replace(
      '{company_id}',
      executorId
    ),
    {
      archive: null,
    }
  );
  return response.data && adjustExecutor(response.data);
};
